var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#bfbfbf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.9941 0c-1.2581 0.01507-2.1789-0.028421-2.9316 0.38672-0.37636 0.20757-0.67321 0.55748-0.83789 0.99609-0.16471 0.43861-0.22461 0.95958-0.22461 1.6172v10c0 0.65761 0.059939 1.1785 0.22461 1.6172 0.16466 0.43866 0.46152 0.79039 0.83789 0.99805 0.75275 0.41537 1.6734 0.37027 2.9316 0.38477h0.0039063 6.0059 0.001953c1.2581-0.01507 2.1789 0.028411 2.9316-0.38672 0.37636-0.20757 0.67321-0.55748 0.83789-0.99609 0.16471-0.43861 0.22461-0.95958 0.22461-1.6172v-8-0.75l-4.25-4.25h-0.75-5.0039-0.0019532zm0.0058594 1h0.0058594 4.9941v4h2 2v8c0 0.59239-0.062656 1.0058-0.16016 1.2656-0.09754 0.2598-0.20135 0.3715-0.38477 0.47266-0.36598 0.20182-1.1965 0.24652-2.4551 0.26172h-6c-1.2585-0.0147-2.0891-0.059799-2.4551-0.26172-0.18341-0.10119-0.28717-0.21275-0.38477-0.47266-0.09756-0.2599-0.16016-0.67324-0.16016-1.2656v-10c0-0.59239 0.062556-1.0058 0.16016-1.2656 0.09754-0.2598 0.20135-0.3715 0.38477-0.47266 0.36598-0.20182 1.1964-0.24652 2.4551-0.26172z",
    color: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 6,
    height: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.8bfe145cf98b924918a1f2cacb142975.svg";
export { ForwardRef as ReactComponent };